import React from 'react';
import RuleForm from './RuleForm';

const EditRule: React.FC = () => {
  return <RuleForm mode="edit" />;
};

export default EditRule;
